import axios from "axios";

// NOTE: NSAI-6847 — what a failed request is logged as. Never the error
// itself: an AxiosError carries the request it failed, and on mobile and the
// extension a refresh request's body is the refresh token.
export interface ILoggedRequestError {
  status?: number;
  code?: string;
  message: string;
}

export const describeRequestError = (error: unknown): ILoggedRequestError => {
  if (axios.isAxiosError(error)) {
    return {
      status: error.response?.status,
      code: error.code,
      message: error.message,
    };
  }

  return { message: error instanceof Error ? error.message : String(error) };
};
